import React, { useEffect, useState } from 'react';
import { Row, Button, Col, Input, Transfer, message, Spin } from 'antd';
import { SearchOutlined, RightOutlined } from '@ant-design/icons';

import api from '../../../../services/api';
import customerPlus from '../../../../assets/icons/customerPlus.svg';
import greenCheck from '../../../../assets/icons/greenCheck.svg';
import binGroup from '../../../../assets/icons/binGroup.svg';
import editGroupIcon from '../../../../assets/icons/editGroup.svg';
import { formatString } from '../../../../helpers/utils';
import { ModalAttendance } from '../../../../components/ModalAttendance';
import * as S from '../styles.js';

export default function UserGroup() {
  const [editGroup, setEditGroup] = useState();
  const [listGroup, setListGroup] = useState([]);
  const [rolesKey, setRolesKey] = useState([]);
  const [rolesVinculadas, setRolesVinculadas] = useState([]);
  const [todasAsRoles, setTodasAsRoles] = useState([]);
  const [newGroup, setNewGroup] = useState(false);
  const [matriz, setMatriz] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loadingReprocessamento, setLoadingReprocessamento] = useState(false);
  const initialTargetKeys = rolesVinculadas.map(item => item.key);

  function TransferRoles({
    editGroup,
    inputGroupCreation,
    setInputGroupCreation,
    initialData,
    setNewGroup,
    newGroup,
  }) {
    const [targetKeys, setTargetKeys] = useState(initialTargetKeys);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [editedName, setEditedName] = useState(false);

    const onChange = nextTargetKeys => {
      setTargetKeys(nextTargetKeys);
    };

    const onSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
      setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
    };

    const salvar = async () => {
      setLoadingReprocessamento(true);
      const roles = [];
      todasAsRoles.forEach(item => {
        targetKeys.forEach(filter => {
          if (filter === item.nome) {
            roles.push(item);
          }
        });
      });

      const payload = {
        id: editGroup.id,
        nome: editedName ? inputGroupCreation : editGroup.nome,
        roles,
      };
      if (newGroup) {
        try {
          await api.post('/grupoUsuario', payload);
          message.success('O grupo criado com sucesso.');
          setEditedName(false);
          setNewGroup(false);
          initialData();
          handleButtonCancel();
        } catch (error) {
          message.error('Não foi possível criar um novo grupo de usuário.');
        }
      } else {
        try {
          await api.put('/grupoUsuario', payload);
          message.success(
            `O grupo ${editGroup.nome} foi alterado com sucesso.`
          );
          setEditedName(false);
          initialData();
          handleButtonCancel();
        } catch (error) {
          message.error('Não foi possível salvar o grupo de usuário.');
        }
      }
      return setLoadingReprocessamento(false);
    };

    const alterName = e => {
      setEditedName(true);
      setInputGroupCreation(e.target.value);
    };

    const renderItemTransfer = item => ({
        label: item?.key,
        value: item?.title,
      });

    return (
      <>
        <Row
          span={24}
          justify="center"
          style={{ marginBottom: '20px', width: '100%' }}
        >
          <Row style={{ marginBottom: 3, width: '100%' }}>
            <span style={styleLocal.title}>Nome do grupo</span>
          </Row>
          <Col id="col" span={24}>
            <Input
              onChange={alterName}
              type="text"
              defaultValue={editGroup.nome || ''}
              placeholder="Digite o nome do grupo"
              span={12}
              style={styleLocal.input}
              suffix={<img src={greenCheck} alt="check" />}
            />
          </Col>
        </Row>
        <Transfer
          dataSource={rolesKey}
          titles={['Lista de Permissões', 'Permissões do grupo']}
          targetKeys={targetKeys}
          selectedKeys={selectedKeys}
          onChange={onChange}
          onSelectChange={onSelectChange}
          render={renderItemTransfer}
        />
        <div style={{ margin: '20px 0' }}>
          <S.StyledButtonCancel
            type="primary"
            htmlType="button"
            onClick={() => handleButtonCancel()}
          >
            Cancelar
          </S.StyledButtonCancel>
          <S.StyledButton
            type="primary"
            htmlType="submit"
            onClick={() => salvar()}
          >
            Salvar
          </S.StyledButton>
        </div>
      </>
    );
  }

  const [inputBusca, setInputBusca] = useState('');

  const styleLocal = {
    input: {
      background: '#F2F2F2',
      border: 'none',
      height: '48px',
      width: '99%',
    },
    rowTop: {
      width: '100%',
      marginTop: '28px',
      display: 'flex',
    },
    colWithe: {
      background: '#fff',
      borderRadius: '2px',
    },
    internCol: {
      borderRadius: '2px',
      height: '680px',
      overflow: 'auto',
      background: '#fff',
      padding: '124px 22px 16px',
    },
    internCol2: {
      borderRadius: '2px',
      height: '680px',
      overflow: 'auto',
      background: '#fff',
      padding: '21px 25px 0 25px',
    },
    formItem: {
      fontWeight: 'bold',
      fontSize: '14px',
      lineHeight: '16px',
      color: '#707070',
      margin: '10px 37px',
    },
    title: {
      fontWeight: 'bold',
      fontSize: '14px',
      lineHeight: '16px',
      color: '#707070',
    },
  };

  const setPermission = async () => {
    const all = todasAsRoles.map(item => ({
        key: item.nome,
        title: item.descricao,
        id: item.id,
      }));
    const vinculadas = rolesVinculadas.map(item => ({
        key: item.nome,
        title: item.descricao,
        id: item.id,
      }));
    setRolesVinculadas(vinculadas);
    return setRolesKey(all);
  };

  const initialData = async () => {
    setLoadingReprocessamento(true);
    try {
      const groupListData = await api.get('/GrupoUsuario/list');
      setListGroup(groupListData.data);
    } catch (error) {
      message.error('Não foi possível carregar os dados de grupo de usuário');
    }
    return setLoadingReprocessamento(false);
  };
  const titleModal = 'Deseja excluir o grupo?';

  const handleInputBusca = e => {
    setInputBusca(e.target.value);
  };

  const remove = item => {
    setMatriz(item);
    toggleModal();
  };

  const toggleModal = () => setIsModalVisible(!isModalVisible);

  const cancelModal = () => toggleModal();

  const okModal = () => {
    toggleModal();
    handleDelete(matriz);
  };

  const handleDelete = async id => {
    setLoadingReprocessamento(true);
    try {
      await api.delete(`grupoUsuario/${id}`);
      message.success('Grupo deletado com sucesso.');
      return initialData();
    } catch (error) {
      message.error(error.response.data.detail);
    }
    return setLoadingReprocessamento(false);
  };

  const filtered = listGroup.filter(item =>
    item.nome.toLowerCase().includes(inputBusca)
  );

  const compare = (a, b) => {
    if (formatString(a.name) < formatString(b.name)) return -1;
    if (formatString(a.name) > formatString(b.noae)) return 1;
    return 0;
  };

  const [activeId, setActiveId] = useState(0);

  function RowsForGroup({ item, index }) {
    return (
      <S.RowsForColumn active={activeId === item.id}>
        <S.RowData
          span={24}
          style={{ color: '#828282', cursor: 'initial' }}
          key={item.id}
          justify="center"
        >
          <S.StyledColRow
            style={{ cursor: 'pointer' }}
            onClick={() => handleEditGroup(item.id)}
            span={8}
          >
            {item.nome}
          </S.StyledColRow>
          <S.StyledColRow style={{ cursor: 'pointer' }} span={8}>
            <img
              onClick={() => handleEditGroup(item.id)}
              src={editGroupIcon}
              alt="edit"
            />
{' '}
          </S.StyledColRow>
          <S.StyledColRow span={7}>
            <img
              style={{ cursor: 'pointer' }}
              src={binGroup}
              alt="bin"
              onClick={() => remove(item.id)}
            />
          </S.StyledColRow>

          <S.StyledColRow span={1}>
            <RightOutlined />
          </S.StyledColRow>
        </S.RowData>
      </S.RowsForColumn>
    );
  }

  const RowUsers = ({ users = [] }) => users?.sort(compare)?.map((item, i) => <RowsForGroup key={i} item={item} index={i} />);

  const handleEditGroup = async id => {
    setActiveId(id);
    setLoadingReprocessamento(true);
    try {
      const response = await api.get(`grupoUsuario/${id}`);
      setRolesVinculadas(response.data.rolesVinculadas);
      setTodasAsRoles(
        response.data.rolesDisponiveis.concat(response.data.rolesVinculadas)
      );
      setEditGroup(response.data);
    } catch (error) {
      message.error('Não foi possível carregar os dados para edição');
    }
    return setLoadingReprocessamento(false);
  };

  useEffect(() => {
    setPermission();
  }, [todasAsRoles]);

  const handleButtonCancel = () => {
    setEditGroup(null);
  };

  const handleNewGroup = async () => {
    setEditGroup({});
    setNewGroup(true);
    setLoadingReprocessamento(true);
    try {
      const response = await api.get('role/list');
      setTodasAsRoles(response.data);
    } catch (error) {
      message.error('Não foi possível carregar as roles.');
    }
    return setLoadingReprocessamento(false);
  };

  function ContentTransfer() {
    const [inputGroupCreation, setInputGroupCreation] = useState('');
    return (
      <S.WrapperTransfer>
        <TransferRoles
          editGroup={editGroup}
          setInputGroupCreation={setInputGroupCreation}
          inputGroupCreation={inputGroupCreation}
          initialData={initialData}
          handleButtonCancel={handleButtonCancel}
          newGroup={newGroup}
          setNewGroup={setNewGroup}
        />
      </S.WrapperTransfer>
    );
  }

  useEffect(() => {
    initialData();
  }, []);

  return (
    <Spin
      spinning={loadingReprocessamento}
      size="large"
      style={{
          width: '100%',
        }}
      tip="Carregando dados de Clientes"
      delay={200}
    >
        <ModalAttendance
          title={titleModal}
          visible={isModalVisible}
          cancelBtn={cancelModal}
          okBtn={okModal}
        />
        <Row style={{ width: '100%' }}>
          <S.StyledCol span={24}>
            <h2>Grupo de usuários</h2>
            <Button
              style={{
                paddingLeft: '8px',
                height: '45px',
                fontWeight: 'bold',
                width: '150px',
                fontSize: '16px',
              }}
              onClick={() => handleNewGroup()}
            >
              <img src={customerPlus} alt="newUser" />
              Novo Grupo
            </Button>
          </S.StyledCol>
        </Row>
        <Row justify="center" id="row" style={styleLocal.rowTop}>
          <Col
            span={editGroup ? 12 : 24}
            style={{
              paddingTop: 0,
              paddingRight: editGroup ? 24 : 0,
            }}
          >
            <Col style={styleLocal.colWithe}>
              <Row
                id="fixe"
                style={{
                  position: 'absolute',
                  width: '99%',
                  background: '#fff',
                  zIndex: '1',
                  padding: '24px 0 0 24px',
                }}
                span={24}
              >
                <Input
                  onChange={handleInputBusca}
                  placeholder="Busca"
                  span={12}
                  style={styleLocal.input}
                  prefix={<SearchOutlined style={{ color: '#24A95D' }} />}
                />
                <Row
                  span={24}
                  style={{
                    width: '99%',
                    background: '#fff',
                    zIndex: '1',
                  }}
                >
                  <S.RowTitle
                    span={24}
                    style={{
                      width: '100%',
                      background: '#fff',
                      borderBottom: '2px solid #CACACA',
                      marginBottom: '3px',
                      color: '#001F2A',
                      fontSize: '12px',
                    }}
                  >
                    <S.StyledColTitle span={8}>Grupo</S.StyledColTitle>
                    <S.StyledColTitle span={8}>Editar</S.StyledColTitle>
                    <S.StyledColTitle span={7}>Excluir</S.StyledColTitle>
                    <S.StyledColTitle span={1} />
                  </S.RowTitle>
                </Row>
              </Row>
              <Col
                justify="center"
                id="col"
                span={24}
                style={styleLocal.internCol}
              >
                <RowUsers span={12} users={filtered || []} />
              </Col>
            </Col>
          </Col>
          <Col span={editGroup ? 12 : 0}>
            <Col style={styleLocal.colWithe}>
              <Col
                justify="center"
                id="col"
                span={24}
                style={styleLocal.internCol2}
              >
                {editGroup && <ContentTransfer />}
              </Col>
            </Col>
          </Col>
        </Row>
    </Spin>
  );
}
